import React, { useState } from "react";
import { bindActionCreators } from "redux";
import { Alert, Card, Col, Row } from "reactstrap";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addTenant } from "../../store/actions/Tenant";
import { RootState } from "../../store/store";
import PageMeta from "components/PageMeta";
import { useOfficeTranslation } from "i18n/OfficeTranslation";

interface Actions {
    addTenant: (n: string) => void;
}

const TenantAddForm: React.FC<Actions> = ({
    addTenant
}) => {
    const { t } = useOfficeTranslation();
    const [error, setError] = useState("")
    const [name, setName] = useState("")
    const navigate = useNavigate();

    const handleValidSubmit = () => {
        if (name === "") {
            setError(t("tenants.tenantAddForm.nameCanTBeEmpty"))
            return
        }

        addTenant(name)
            //@ts-ignore
            .then(() => {
                navigate("/tenants");
            })
            .catch(() => {
                setError(t("tenants.tenantAddForm.addingTenancyHasFailedCheckDataAndTryAgain"))
            });

    };

    return (
        <>
            <PageMeta title={t("tenants.tenantAddForm.addTenant")} />
            <div className="account-pages my-5 pt-sm-5">
                <Row className="justify-content-center">
                    <Col md={10}>
                        <Card className="overflow-hidden">
                            <Row className="g-0">
                                <div className="p-lg-5 p-4">
                                    <div>
                                        <h5>{t("tenants.tenantAddForm.addTenant")}</h5>
                                    </div>
                                    <div className="mt-4 pt-3">
                                        {
                                            error &&
                                            <Alert color="danger">{error}</Alert>
                                        }
                                        <div className="form-floating mb-3">
                                            <input type="text" className="form-control" placeholder={t("common.name")} onInput={e => {
                                                setName(e.currentTarget.value)
                                            }} />
                                            <label className="">{t("common.name")}</label>
                                        </div>

                                        <div className="mt-3">
                                            <button
                                                className="btn btn-primary w-100 waves-effect waves-light"
                                                onClick={() => {
                                                    handleValidSubmit()
                                                }}
                                            >
                                                {t("common.add")}
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </Row>
                        </Card>
                    </Col>
                </Row>

            </div>
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators({ addTenant }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(TenantAddForm);
